import { useState } from "react";
import { Box, Flex, Text, Accordion, Icon, Heading } from "@chakra-ui/react";
import { HiPlus, HiMinus } from "react-icons/hi";

import { clientFaqs } from "../core/constants";

export const FAQs = () => {
  const [activeItem, setActiveItem] = useState(["a"]);

  const handleValueChange = ({ value }: any) => {
    setActiveItem(value.length ? [value[value.length - 1]] : []);
  };

  return (
    <Box
      py={{ base: "60px", lg: "90px" }}
      bg="#FFF"
      px={{ base: "16px", lg: "0" }}
      maxW={{ base: "100%", "2xl": "1700px" }}
      mx="auto"
    >
      <Flex
        flexDir={"column"}
        gap={{ base: "16px", lg: "20px" }}
        align={"center"}
      >
        <Heading
          fontSize={{ base: "28px", lg: "52px" }}
          color={"#19202D"}
          lineHeight={"100%"}
          fontFamily={"LeagueSpartan"}
          textAlign={"center"}
          mb="44px"
        >
          Frequently asked questions
        </Heading>

        <Accordion.Root
          w="100%"
          maxW="977px"
          value={activeItem}
          onValueChange={handleValueChange}
          collapsible
          defaultValue={["a"]}
          borderWidth={"1px"}
          borderColor="#E5E9EC"
          borderRadius={"20px"}
        >
          {clientFaqs.map((item, index) => {
            const isLast = index === clientFaqs.length - 1;
            // const isFirst = index === 0;
            const isActive = activeItem.includes(item.id);

            return (
              <Accordion.Item
                key={index}
                value={item.id}
                p={{ base: "16px", md: "20px" }}
                borderBottomWidth={isLast ? 0 : 1}
                borderColor="#E5E9EC"
              >
                <Accordion.ItemTrigger>
                  <Text
                    flex="1"
                    color={"#000"}
                    fontSize={{ base: "18px", md: "20px", lg: "24px" }}
                    fontFamily={"LeagueSpartan"}
                    fontWeight={400}
                  >
                    {item.title}
                  </Text>

                  <Icon size={"lg"} color="#FF8E3C">
                    {isActive ? <HiMinus /> : <HiPlus />}
                  </Icon>
                </Accordion.ItemTrigger>

                <Accordion.ItemContent>
                  <Accordion.ItemBody
                    color={"#19202D"}
                    fontSize={{ base: "14px", md: "15px", lg: "16px" }}
                    lineHeight={{ base: "150%", lg: "160%" }}
                  >
                    {item.body}
                  </Accordion.ItemBody>
                </Accordion.ItemContent>
              </Accordion.Item>
            );
          })}
        </Accordion.Root>
      </Flex>
    </Box>
  );
};
